export default "__VITE_ASSET__D6SzuDuZ__"